import * as Popover from '@radix-ui/react-popover';
import { cn } from '@shared/cove-ui';
import type { ComponentProps } from 'react';

export interface IAsteriskProps extends ComponentProps<typeof Popover.Content> {
  asteriskClassname?: string;
  children?: React.ReactNode;
}

const Asterisk = ({
  children,
  className,
  sideOffset = 2,
  side = 'top',
  align = 'end',
  asteriskClassname = '',
  ...props
}: IAsteriskProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger className="mb-auto inline-flex h-full items-start bg-transparent align-top">
        <span
          className={cn(
            'border-cove-dove text-cove-navy-blue mb-auto inline-flex h-4 w-4 items-center justify-center rounded-full border bg-white pt-1 text-sm font-light leading-none',
            asteriskClassname
          )}
        >
          *
        </span>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className={cn(
            'bg-cove-baby-dove px-cove-25 py-cove-10 max-w-[267px] rounded text-center text-xs',
            className
          )}
          side={side}
          align={align}
          sideOffset={sideOffset}
          {...props}
        >
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default Asterisk;
